import { createAction } from '@reduxjs/toolkit';

export const bookingUpdateId = createAction('booking/updateId');
export const bookingUpdateUID = createAction('booking/updateUid');
export const bookingUpdateSID = createAction('booking/updateSid');
export const bookingUpdateIsAdded = createAction('booking/updateIsAdded');
export const bookingUpdateIsActive = createAction('booking/updateIsActive');

export const bookingStore = createAction('booking/store');
export const bookingClear = createAction('booking/clear');

export const bookingUpdateRequest = createAction('booking/updateRequest');
export const bookingUpdateIsLoading = createAction('booking/updateIsLoading');
export const bookingUpdateError = createAction('booking/updateError');
export const bookingUpdateStore = createAction('booking/updateStore');

export const bookingUpdateItems = createAction('booking/updateItems');
export const bookingUpdateHeading = createAction('booking/updateHeading');
export const bookingUpdateBlockContent = createAction('booking/updateBlockContent');
export const bookingUpdateBlockDesign = createAction('booking/updateBlockDesign');
export const bookingUpdateRentalType = createAction('booking/updateRentalType');
export const bookingUpdateActiveItem = createAction('booking/updateActiveItem');
